import React from "react";
import { Box, Container, Fab, Grid } from "@material-ui/core";
import { Link, useLocation } from "react-router-dom";
import { Icon, Loading, ErrorBox, Text } from "shared";
import { Search } from "@material-ui/icons";
import { Area } from "types";
import { join } from "utils/misc";
import useGetUser from "./queries/useGetUser";
import { Account } from "./components";

export const User: React.VFC = () => {
  const { state } = useLocation<string | undefined>();
  const { data: user, isLoading, error, isLoadingError } = useGetUser();

  const content = isLoading ? (
    <Loading />
  ) : isLoadingError ? (
    <ErrorBox error={error} verbose centered />
  ) : user ? (
    <Grid container spacing={2}>
      <Grid item zeroMinWidth md={7}>
        <Account user={user} />
      </Grid>
      <Grid item zeroMinWidth md={5}></Grid>
    </Grid>
  ) : (
    <Text secondary center>
      User not found
    </Text>
  );

  return (
    <div>
      <Box ml={3} mt={3} mb={4}>
        <Link to={join(Area.Users, state)}>
          <Fab color="secondary" size="medium" aria-label="Back to search">
            <Icon of={Search} />
          </Fab>
        </Link>
      </Box>
      <Container maxWidth="md">{content}</Container>
    </div>
  );
};
